import Link from 'next/link';

import { Menu } from 'lucide-react';

import { addLocalePrefix, resolveLocaleOrDefault } from '@kit/i18n';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@kit/ui/dropdown-menu';
import { NavigationMenu, NavigationMenuList } from '@kit/ui/navigation-menu';
import { Trans } from '@kit/ui/trans';

import pathsConfig from '~/config/paths.config';

import { SiteNavigationItem } from './site-navigation-item';

const links = {
  Product: {
    label: 'marketing:product',
    hash: 'product',
  },
  ForCompanies: {
    label: 'marketing:forCompanies',
    hash: 'businesses',
  },
  Pricing: {
    label: 'marketing:pricing',
    hash: 'pricing',
  },
  AboutUs: {
    label: 'marketing:aboutUs',
    hash: 'about-us',
  },
  FAQ: {
    label: 'marketing:faq',
    hash: 'faq',
  },
  Contact: {
    label: 'marketing:contact',
    hash: 'contact-us',
  },
};

export function SiteNavigation(props: { language?: string }) {
  const language = resolveLocaleOrDefault(props.language);
  const homePath = addLocalePrefix('/', language);

  const NavItems = Object.values(links).map((item) => {
    const path = `${homePath}#${item.hash}`;

    return (
      <SiteNavigationItem key={path} path={path}>
        <Trans i18nKey={item.label} />
      </SiteNavigationItem>
    );
  });

  return (
    <>
      <div className={'hidden items-center justify-center lg:flex'}>
        <NavigationMenu className={'px-4 py-2'}>
          <NavigationMenuList
            className={'space-x-5 xl:space-x-7 2xl:space-x-10'}
          >
            {NavItems}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      <div className={'flex items-center justify-start lg:hidden'}>
        <MobileDropdown homePath={homePath} />
      </div>
    </>
  );
}

function MobileDropdown(props: { homePath: string }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={'Open Menu'}
        className="flex h-8 w-8 items-center justify-center align-middle"
      >
        <Menu className={'h-8 w-8'} />
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        sideOffset={12}
        className={'mt-2 w-full'}
      >
        {Object.values(links).map((item) => {
          const className = 'flex w-full h-full items-center';
          const path = `${props.homePath}#${item.hash}`;

          return (
            <DropdownMenuItem key={path} asChild>
              <Link className={className} href={path}>
                <Trans i18nKey={item.label} />
              </Link>
            </DropdownMenuItem>
          );
        })}

        <DropdownMenuItem asChild>
          <Link
            className="flex h-full w-full items-center"
            href={pathsConfig.auth.signIn}
          >
            <Trans i18nKey={'auth:signIn'} />
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
